import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteGameday = async ({ orgId, gamedayId }) => {
  const url = `v1/orgs/${orgId}/gamedays/${gamedayId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default deleteGameday
